import React from 'react';
import { Button } from 'antd';

const notFound = () => {
  return(
    <div>
      <div>Not Found</div>
      <div>If you have been redirected to this page from "https://portal.sow-evangelism.com/auth/login" click the button below, navigate to "https://portal.sow-evangelism.com/auth/login" and try to log in again.</div>
      <Button onClick={() => { localStorage.removeItem('authenticationToken'); }} type="primary">
        Clear authenication token
      </Button>
    </div>
  );
};

export default notFound;



// WEBPACK FOOTER //
// ./src/components/pages/notFound/notFound.js